import React, { FunctionComponent, useContext } from 'react';
import styles from './grid.module.scss';
import classNames from 'classnames/bind';
import { Column, IColumnProps } from './column/column';
import { AppStore } from '../../store/app.context';
import { checkDevice } from '../../utils/utils';
import { SpaceBetweenColumnsType } from '../../typings';
import { marginBetweenItemsClasses } from '../../utils/utils';

export interface IGridProps {
  columns: IColumnProps[];
  marginBetweenItems: SpaceBetweenColumnsType;
  wrappColumns: string;
  wrappColumnsReverse: boolean;
  autoWidth: boolean;
  id: string;
}

const cx = classNames.bind(styles);

export const Grid: FunctionComponent<IGridProps> = ({
  columns,
  marginBetweenItems,
  wrappColumns,
  wrappColumnsReverse,
  id,
  autoWidth
}) => {
  const { state } = useContext(AppStore);
  const { showActiveDevice } = state;
  const marginBetweenItemsClass = marginBetweenItemsClasses(marginBetweenItems);

  const gridClass = cx({
    ...marginBetweenItemsClass,
    wrappColumnsReverse: wrappColumnsReverse
  });

  const checkColumnWidth = (): string => {
    const autoColumntWidth = 'auto ';

    if (autoWidth) {
      return autoColumntWidth.repeat(columns.length);
    }
    return `repeat(${columns.length}, 1fr)`;
  };

  return (
    <div
      id={id}
      className={`
        ${styles.grid} 
        ${gridClass} 
        ${
          showActiveDevice <= checkDevice(wrappColumns) && wrappColumnsReverse
            ? styles.gridReversed
            : null
        }`}
      style={{
        gridTemplateColumns: `${
          showActiveDevice > checkDevice(wrappColumns) ||
          wrappColumns === 'none'
            ? checkColumnWidth()
            : `1fr`
        }`
      }}
    >
      {columns.map((column, i) => (
        <Column {...column} key={i} />
      ))}
    </div>
  );
};
